import { useRoutes } from "react-router-dom";

import AdminRoutes from "./AdminRoutes";
import KalypayRoutes from "../Front/Routes/Routes";
import LandingRoutes from "../Landing/routes/LandingRoutes";
import AuthRoutes from "./AuthRoutes";
import { isAdminDomain } from "../constant/isAdminDomain";
import Error from "../Landing/pages/Error/Error";

const AppRoutes = () => {
    const all_routes = isAdminDomain
        ? [
              ...AdminRoutes,
              ...AuthRoutes,
              {
                  path: "*",
                  element: <Error />,
              },
          ]
        : [...LandingRoutes, ...KalypayRoutes];
    const routes = useRoutes([...all_routes]);

    return <>{routes}</>;
};

export default AppRoutes;
